export const NIT_ZIBOR = "900114098";